import { useState, useEffect } from "react";
import { getServerUri } from "./uriUtility";
import { apiURI } from "./apiURI";

/**
 * companyLogo holds one of two shapes: an absolute url (every logo that predates
 * uploading, sitting in the playin-companylogos S3 bucket) or a path relative to
 * the API host (anything uploaded since). Both have to render.
 *
 * getServerUri is not used here — it appends a trailing slash, which is right
 * for an endpoint and wrong for a file.
 */
export function resolveLogoUrl(storedValue) {
  if (!storedValue) return "";
  if (/^(https?:)?\/\//i.test(storedValue) || storedValue.startsWith("data:")) return storedValue;
  return apiURI + (storedValue.startsWith("/") ? "" : "/") + storedValue;
}

/* fetch companylogo using company id from uploadLogo. it return companylogo url
 * @param companyId
 * @returns logoUrl
 */
export function fetchCompanyLogo(companyId) {
  const [companyLogoUrl, setCompanyLogoUrl] = useState("");
  useEffect(() => {
    if (!companyId) return;
    let active = true;
    const controller = new AbortController();
    fetch(getServerUri("company/uploadLogo"), {
      signal: controller.signal,
      method: "POST",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        companyID: companyId,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json().then((json) => {
            if (active) setCompanyLogoUrl(resolveLogoUrl(json.logoUrl));
          });
        } else {
          return response.text().then((responseText) => {
            console.log(responseText);
          });
        }
      })
      .catch((error) => {
        if (active && error.name !== "AbortError") console.error(error);
      });
    return () => {
      active = false;
      controller.abort();
    };
  }, [companyId]);
  return companyLogoUrl;
}
